export enum BookingAction {
  confirmBooking = "confirmBooking",
  parkingEntry = "parkingEntry",
  parkingDeparture = "parkingDeparture",
  endBooking = 'endBooking',
  userCancelBooking = 'userCancelBooking',
}
